import React from "react";
import { Button, Card, Heading, Stack, Text } from "@origin-digital/ods-core";
import { eventDispatcher, TOPICS } from "@origin-digital/event-dispatcher";
import content from "./content.json";

const handleUpdateMarketPreferencesClick = () =>
  eventDispatcher.dispatch({
    topic: TOPICS.NAV_TO,
    payload: {
      to: "marketPreferences",
    },
  });

export const MarketPrefsCard: React.FC = () => (
  <Card>
    <Stack>
      <Heading variant="h3">{content.marketprefs.heading}</Heading>
      <Text>{content.marketprefs.description}</Text>
      <Button
        variant="outlined"
        data-id="market-prefs-button"
        onClick={handleUpdateMarketPreferencesClick}
      >
        {content.marketprefs.button}
      </Button>
    </Stack>
  </Card>
);
